import React, { useRef, useEffect } from 'react';
import Chart from 'chart.js/auto';

const RadarChart = ({ data }) => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!Array.isArray(data) || data.length === 0) return;

    const ctx = canvasRef.current.getContext('2d');

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    chartRef.current = new Chart(ctx, {
      type: 'radar',
      data: {
        labels: data.map(item =>
          item.drill_name.length > 22
            ? item.drill_name.slice(0, 20) + '...'
            : item.drill_name
        ),
        datasets: [
          {
            label: 'Accuracy (%)',
            data: data.map(item => Math.round((item.shooting_pct ?? 0) * 100)),
            borderColor: '#FFA500',
            backgroundColor: 'rgba(255, 165, 0, 0.2)',
            pointBackgroundColor: '#FFA500',
            fill: true
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false, // ✅ Prevent overflow
        plugins: {
          legend: { position: 'top' },
          tooltip: {
            callbacks: {
              label: (context) => `${context.parsed.r}%`
            }
          }
        },
        scales: {
          r: {
            min: 0,
            max: 100,
            ticks: {
              stepSize: 20,
              callback: (value) => `${value}%`
            },
            pointLabels: {
              font: { size: 12 }
            },
            grid: { color: '#000000' },
            angleLines: { color: '#000000' }
          }
        }
      }
    });
  }, [data]);

  return (
    <div style={{ width: '100%', maxWidth: '600px', height: '400px', margin: '0 auto' }}>
      {(!Array.isArray(data) || data.length === 0) ? (
        <p>No chart data available.</p>
      ) : (
        <canvas ref={canvasRef} />
      )}
    </div>
  );
};

export default RadarChart;


